import { render } from "./article-plat-list.vue?vue&type=template&id=4f0bb31e&scoped=true&ts=true"
import script from "./article-plat-list.vue?vue&type=script&lang=ts"
export * from "./article-plat-list.vue?vue&type=script&lang=ts"

import "./article-plat-list.vue?vue&type=style&index=0&id=4f0bb31e&scoped=true&lang=less"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f0bb31e"]])

export default __exports__